import React, { useState, useEffect } from 'react';

import Modal from 'components/UI/Modal';
import Input from 'components/UI/Input';
import { renderToast, toast } from 'components/UI/ToastNotification';
import { useAuth } from 'lib/Auth';
import Attribute, { AttributeValueRequest, emptyAttributeValueRequest } from 'data/Attribute';
import { addAttributeValue } from 'requests/atribute';

interface Props {
    onClose: () => void;
    attribute: Attribute;
    addValue: (newValue: AttributeValueRequest) => void;
    title: string;
    showModal: boolean;
};

const AddAttributeValueModal = ({ onClose, attribute, addValue, title, showModal }: Props) => {
    const [newValue, setNewValue] = useState<AttributeValueRequest>(emptyAttributeValueRequest);
    const { token } = useAuth();

    useEffect(() => {
        if (attribute) {
            setNewValue({ ...emptyAttributeValueRequest, attributeId: attribute.id, displayOrder: attribute.values.length + 1 });
        } else {
            setNewValue(emptyAttributeValueRequest);
        }
    }, [attribute]);

    const handleClick = () => {
        addAttributeValue(token!, newValue)
            .then(res => {
                renderToast(toast.TYPE.SUCCESS, 'Value created successfully.');
                addValue(res);
                setNewValue(emptyAttributeValueRequest);
            })
            .catch(err => {
                renderToast(toast.TYPE.ERROR, err.message);
            });

        onClose();
    };

    const handleClose = () => {
        onClose();
        setNewValue(emptyAttributeValueRequest);
    };

    const handleInputChange = (name: string) => {
        setNewValue({ ...newValue, name, attributeId: attribute.id });
    };

    const cantSubmit = newValue.name === '' || attribute.values.some(el => el.name === newValue.name);

    return (
        <Modal
            showModal={showModal}
            showCloseIcon
            onClose={handleClose}
            onClick={handleClick}
            disabled={cantSubmit}
            title={title}
            primaryButtonText='Save'
        >
            <Input
                id='add-attribute-value-modal-name-id'
                placeholder='Attribute value'
                labelName="Name"
                onInputChange={handleInputChange}
                value={newValue.name}
            />
        </Modal>
    );
};

export default AddAttributeValueModal;
